<template>
	<div class="paging">
		<el-pagination
			background
			:hide-on-single-page="show"
			next-text="下一页"
			prev-text="上一页"
			@size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
			:page-size="pageSize"
			layout="prev, pager, next, jumper, total"
			:total="total">
		</el-pagination>
	</div>
</template>
<script>
export default {
	name: 'menuList',
  props: {
   total: {
		 type: Number,
		 default: 0,
	 },
	 pageSize: {
		 type: Number,
		 default: 10,
	 },
  },
  data() {
    return {
		 currentPage: 1,
		 show: true,
    }
  },
	mounted() {
	},
	methods: {
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.$emit('handleCurrentChange', val);
		}
	}
}
</script>

<style scoped>
.paging {
  background-color: #ccc;
  width: 100%;
  height: 70px;
  text-align: center;
  line-height: 70px;
	position: relative;
  box-sizing: border-box;
	font-family: Microsoft YaHei;
}
.paging >>> .el-pagination {
	padding: 0;
	transform: translate(-50%, -25%);
	position: absolute;
	left: 50%;
	top: 50%;
}
.paging >>> .el-pagination__total {
 margin-left: 20px;
}
.el-pagination.is-background .el-pager li:hover {
  color: #205eab;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #205eab;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #205eab;
  color: #fff;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #205eab;
}
.paging >>> .el-pagination.is-background .btn-next,
.paging >>> .el-pagination.is-background .btn-prev {
  padding: 0 20px;  /* 增加左右内边距 */
  min-width: 100px;  /* 设置最小宽度 */
  margin: 0 10px;  /* 增加按钮之间的间距 */
  background-color: #ccc;
  color: #fff;
}

.paging >>> .el-pagination.is-background .btn-next:hover,
.paging >>> .el-pagination.is-background .btn-prev:hover {
  color: #205eab;  /* 保持鼠标悬停效果 */
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #205eab;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  background-color: #ccc;
  color: #fff;
}
</style>
